import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// IMPORTANT: This import registers the AI Denoiser extension at module load time
// It MUST be imported BEFORE App (which eventually loads AgoraContext and creates audio tracks)
import "./services/noiseCancellationInit";
import App from "./App";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// One-time migration: earlier builds defaulted cameraResolution to '1080p' in
// SettingsModal, which silently opted hosts/co-hosts into 1080p publishing the
// first time they opened Settings. Rewrite stale '1080p' values back to '480p'
// so existing users get the corrected default. Safe to remove after a few weeks.
if (typeof window !== "undefined") {
  try {
    const raw = localStorage.getItem("rlink_settings");
    if (raw) {
      const s = JSON.parse(raw);
      if (s && s.cameraResolution === "1080p") {
        s.cameraResolution = "480p";
        localStorage.setItem("rlink_settings", JSON.stringify(s));
      }
    }
  } catch {}
}

// Prevent pinch zoom on mobile
if (typeof window !== "undefined") {
  let lastTap = 0;
  
  // Prevent pinch zoom (multiple touches)
  document.addEventListener(
    "touchstart",
    function (event) {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    },
    { passive: false }
  );

  // Prevent double-tap zoom and rapid taps
  document.addEventListener(
    "touchend",
    function (event) {
      const currentTime = new Date().getTime();
      const tapLength = currentTime - lastTap;
      // Prevent double-tap zoom (taps within 300ms)
      if (tapLength < 300 && tapLength > 0) {
        event.preventDefault();
      }
      lastTap = currentTime;
    },
    { passive: false }
  );

  // Prevent gesture-based zoom (iOS Safari)
  document.addEventListener(
    "gesturestart",
    function (e) {
      e.preventDefault();
    },
    { passive: false }
  );

  document.addEventListener(
    "gesturechange",
    function (e) {
      e.preventDefault();
    },
    { passive: false }
  );

  document.addEventListener(
    "gestureend",
    function (e) {
      e.preventDefault();
    },
    { passive: false }
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <ToastContainer
      toastClassName={(context) =>
        `${context?.defaultClassName} relative flex py-4 px-3 rounded overflow-hidden cursor-pointer bg-white shadow-lg`
      }
      bodyClassName={(context) =>
        `${context?.defaultClassName} text-[#000] text-base font-bold`
      }
      position="bottom-left"
      autoClose={4000}
      hideProgressBar={true}
      newestOnTop={false}
      closeButton={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      style={{ zIndex: 999999 }}
    />
    <App />
  </>
);
